var React = require('react');

function IconCaret (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1 1L5 5L9 1","strokeWidth":"1.5"}));
}

IconCaret.defaultProps = {"viewBox":"0 0 10 7","fill":"none"};

module.exports = IconCaret;

IconCaret.default = IconCaret;
